function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter-1"
}, /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceGraphic",
  type: "matrix",
  values: "0 0 0 0 0.266667 0 0 0 0 0.266667 0 0 0 0 0.266667 0 0 0 1.000000 0"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "FINAL-10/13/20",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Icon-S_OnLight_Heart_Default_On",
  transform: "translate(-114.000000, -684.000000)",
  filter: "url(#filter-1)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(114.000000, 684.000000)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-Copy-29",
  x: 0,
  y: 0,
  width: 16,
  height: 16
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.99682617,13.5478516 C8.13012695,13.5478516 8.33325195,13.4589844 8.47924805,13.3637695 C11.8498535,11.1992188 14.001709,8.67919922 14.001709,6.12109375 C14.001709,3.96923828 12.5163574,2.45214844 10.6184082,2.45214844 C9.43774414,2.45214844 8.54272461,3.09960938 7.99682617,4.09619141 C7.46362305,3.10595703 6.5559082,2.45214844 5.37524414,2.45214844 C3.47729492,2.45214844 1.99829102,3.96923828 1.99829102,6.12109375 C1.99829102,8.67919922 4.14379883,11.1992188 7.5144043,13.3637695 C7.66674805,13.4589844 7.86352539,13.5478516 7.99682617,13.5478516 Z",
  id: "Heart",
  fill: "#444444",
  fillRule: "nonzero"
}))));

function SvgIconFavoritedActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon-S_OnLight_Heart_Default_On") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFavoritedActive);
export default __webpack_public_path__ + "static/media/icon_favorited_active.8a087bdf.svg";
export { ForwardRef as ReactComponent };